import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: inline-block;
  margin-left: 5px;
`;

const ClickableIcon = styled.p`
  width: 16px;
  height: 16px;
  margin: 0 !important;
  padding: 2px 0;
  background: #bdbdbd;
  border-radius: 8px;
  line-height: 13px;
  font-family: Basier Circle;
  font-weight: 700;
  font-size: 11px;
  text-align: center;
  letter-spacing: -0.2px;
  color: #fff;
  cursor: pointer;

  :hover {
    background: #000;
  }
`;

const StyledDialog = withStyles({
  paper: {
    maxWidth: '350px',
    borderRadius: '11px',
  },
})(Dialog);

const StyledDialogTitle = withStyles({
  root: {
    backgroundColor: '#000',
    padding: '8px',
  },
})(DialogTitle);

const CrossIcon = withStyles({
  root: {
    color: '#FFF',
    transform: 'rotate(45deg)',
    float: 'right',
    cursor: 'pointer',
  },
})(AddIcon);

export default function TooltipModal(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Container>
      <ClickableIcon onClick={handleOpen}>?</ClickableIcon>
      <StyledDialog open={open} onClose={handleClose}>
        <StyledDialogTitle>
          <CrossIcon onClick={handleClose} />
        </StyledDialogTitle>
        <DialogContent>{props.children}</DialogContent>
      </StyledDialog>
    </Container>
  );
}

export const TooltipHeader = styled.h2`
  font-weight: 500;
  letter-spacing: -0.4px;
`;

export const TooltipContent = styled.div`
  font-size: 13px;
  letter-spacing: -0.2px;
  line-height: 18px;

  em {
    color: #797979;
    font-style: normal;
  }

  a {
    color: #000;
  }
`;

export const TooltipSectionTitle = styled.p`
  margin-top: 25px;
  font-weight: 700;
`;



// WEBPACK FOOTER //
// ./src/components/Utility/TooltipModal/index.jsx